<div class="price old-price breadcrumb" [class.inline]="inline()">
    @if (price()) {
        <p class="body-1">{{ price() | currency }}</p>
    }
    @if (canRedeemPoints()) {
        <p class="body-1" [ngClass]="{ 'left-offset': inline() }">
            <span class="points-equiv">{{ points() | appDigitsGrouping }} pts</span>
        </p>
    }
</div>
